module.exports = __webpack_public_path__ + "img/10.5f9ad00a.png";